import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

import withCardBackgroundColor from '../../hoc/with-card-background-color';
import withFontClassName from '../../hoc/with-font-class-name';
import withTranslate from '../../hoc/with-translate';
import styles from './more-button.scss';
import { MoreIcon } from '../icons';
import { handleEnterKeyUp, handleEscapeKeyUp } from '../../services/accessibility';

const BOTTOM_THRESHOLD = 60;

export class MoreButton extends Component {
  state = {
    isVisible: false,
  };

  handleClick = event => {
    if (this.state.isVisible) {
      this.hideComponent();
    } else {
      this.showComponent();
    }
    event.preventDefault();
  };

  setContainer = element => (this.container = element);

  setActionsContainer = element => (this.actionsContainer = element);

  checkIfFits = () => {
    const rect = this.container.getBoundingClientRect();
    const scrollOffset = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    const bodyHeight = document.body.offsetHeight;
    const topOffset = scrollOffset + rect.top;
    const bottomOffset = bodyHeight - topOffset - rect.height;
    const actionsHeight = this.actionsContainer ? this.actionsContainer.offsetHeight : 0;
    this.setState({
      isAtTop: actionsHeight > bottomOffset - BOTTOM_THRESHOLD && actionsHeight < topOffset,
    });
  };

  showComponent = () => {
    document.addEventListener('click', this.hideComponent);
    this.setState(
      {
        isVisible: true,
      },
      this.checkIfFits
    );
  };

  hideComponent = () => {
    document.removeEventListener('click', this.hideComponent);
    this.setState({
      isVisible: false,
    });
  };

  componentWillUnmount = () => {
    document.removeEventListener('click', this.hideComponent);
  };

  renderActionsContainer = () => {
    const { contentFontClassName, cardBackgroundColor } = this.props;
    const actionsContainerClass = classNames(
      styles.actions,
      contentFontClassName,
      'forum-text-color',
      'default-forum-card-background-color',
      { [styles.actionsTop]: this.state.isAtTop }
    );
    const actionsContainerStyle = {
      backgroundColor: cardBackgroundColor,
    };

    return (
      <div
        className={actionsContainerClass}
        style={actionsContainerStyle}
        role="menu"
        aria-live="polite"
        ref={this.setActionsContainer}
        data-hook="actions"
      >
        {this.props.children}
      </div>
    );
  };

  render = () => {
    const { id, icon, t, isWhite, className: buttonClassName } = this.props;
    const className = classNames(buttonClassName, styles.more, 'more-button', {
      [styles.moreWhite]: isWhite,
    });

    return (
      <div
        onClick={this.handleClick}
        className={className}
        ref={this.setContainer}
        onKeyUp={handleEscapeKeyUp(this.hideComponent)}
        data-hook="more-button"
      >
        <div
          className={styles.icon}
          tabIndex="0"
          role="menubar"
          aria-label={t('more-button.more-actions')}
          onKeyUp={handleEnterKeyUp(this.handleClick)}
          id={id}
        >
          {icon}
        </div>
        {this.state.isVisible ? this.renderActionsContainer() : null}
      </div>
    );
  };
}

MoreButton.propTypes = {
  cardBackgroundColor: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  isWhite: PropTypes.bool,
  id: PropTypes.string,
  icon: PropTypes.node,
  t: PropTypes.func.isRequired,
};

MoreButton.defaultProps = {
  icon: <MoreIcon className={classNames(styles.moreIcon, 'forum-icon-fill')}/>,
};

export default flowRight(
  withCardBackgroundColor,
  withTranslate,
  withFontClassName
)(MoreButton);



// WEBPACK FOOTER //
// ./app/components/more-button/more-button.js